import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RippleModule } from 'primeng/ripple';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DashboardItemComponent } from './dashboard-item/dashboard-item.component';
import { LoginComponent } from './login/login.component';
import { RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { DropdownModule } from 'primeng/dropdown';
import { MessageService } from 'primeng/api';
import { AuthGuard } from './guards/auth.guard';
import { LoadingInterceptorService } from './services/LoadingInterceptor.service';
import { NhanSuComponent } from './nhan-su/nhan-su.component';
import { FieldsetModule } from 'primeng/fieldset';
import { ToolbarModule } from 'primeng/toolbar';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { PanelModule } from 'primeng/panel';
import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { BadgeModule } from 'primeng/badge';
import { DialogModule } from 'primeng/dialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { PaginatorModule } from 'primeng/paginator';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DividerModule } from 'primeng/divider';
import { CalendarModule } from 'primeng/calendar';
import { LoaiHopDongComponent } from './loai-hop-dong/loai-hop-dong.component';
import { NguoiYeuCauComponent } from './nguoi-yeu-cau/nguoi-yeu-cau.component';
import { SoCaiComponent } from './so-cai/so-cai.component';
import { UploadComponent } from './upload/upload.component';
import { TimKiemComponent } from './tim-kiem/tim-kiem.component';
import { SidebarModule } from 'primeng/sidebar';
import { MenubarModule } from 'primeng/menubar';
import { MenuItem } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';
import { MainMenuComponent } from './main-menu/main-menu.component';
import { MenuModule } from 'primeng/menu';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SplitterModule } from 'primeng/splitter';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ChartModule } from 'primeng/chart';
import { ThongkeTitleComponent } from './thongke-title/thongke-title.component';
// import { EditorModule } from 'primeng/editor';
@NgModule({
  declarations: [
    AppComponent,
    DashboardItemComponent,
    LoginComponent,
    HomeComponent,
    NhanSuComponent,
    LoaiHopDongComponent,
    NguoiYeuCauComponent,
    SoCaiComponent,
    UploadComponent,
    TimKiemComponent,
    MainMenuComponent,
    ChangePasswordComponent,
    ThongkeTitleComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    RippleModule,
    SplitterModule,
    ReactiveFormsModule,
    CardModule,
    MenuModule,
    SplitButtonModule,
    ButtonModule,
    MenubarModule,
    TooltipModule,
    InputTextModule,
    FormsModule,
    ToastModule,
    FieldsetModule,
    ToolbarModule,
    SidebarModule,
    PanelModule,
    TableModule,
    AutoCompleteModule,
    CheckboxModule,
    InputSwitchModule,
    PaginatorModule,
    InputTextareaModule,
    InputNumberModule,
    DialogModule,
    DividerModule,
    CalendarModule,
    DropdownModule,
    BadgeModule,
    ChartModule,
    RouterModule.forRoot([
      { path: '', component: LoginComponent },
      { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
      { path: 'nhansu', component: NhanSuComponent, canActivate: [AuthGuard] },
      { path: 'loaihopdong', component: LoaiHopDongComponent, canActivate: [AuthGuard] },
      { path: 'nguoiyeucau', component: NguoiYeuCauComponent, canActivate: [AuthGuard] },
      { path: 'socai', component: SoCaiComponent, canActivate: [AuthGuard] },
      { path: 'socai/:id', component: SoCaiComponent, canActivate: [AuthGuard] },
      { path: 'timkiem', component: TimKiemComponent, canActivate: [AuthGuard] },
      // { path: '', redirectTo: 'login', pathMatch: 'full' }
    ])
  ],
  providers: [MessageService, AuthGuard, {
    provide: HTTP_INTERCEPTORS,
    useClass: LoadingInterceptorService,
    multi: true
  },],
  bootstrap: [AppComponent]
})
export class AppModule { }
